module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Ticket Summary")]), _vm._v(" "), _c('good-table', {
    attrs: {
      "cols": _vm.cols,
      "rows": _vm.list,
      "row-style": _vm.cellClass
    }
  }), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-895f8544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/maintenance/TicketSummary.vue
// module id = 1588
// module chunks = 0